import React, { createContext, useCallback, useContext, useState, } from 'react';
import Directions from '@polestar/component-warehouse-react/tokens/directions/Directions';
import { useUpdateEffect } from '@polestar/component-warehouse-react/hooks/useUpdateEffect';
import { isSSR } from '@polestar/component-warehouse-react/helpers/supports';
export const DirectionContext = createContext({
    isRTL: false,
    isLTR: true,
    isArabic: false,
    direction: Directions.leftToRight,
    toggleDirection: () => null,
    setDirection: () => null,
});
const DirectionProvider = ({ children, forcedDirection, initialDirection }) => {
    const [direction, setDirection] = useState(forcedDirection || initialDirection || Directions.leftToRight);
    useUpdateEffect(() => {
        if (forcedDirection) {
            setDirection(forcedDirection);
        }
    }, [forcedDirection]);
    const isRTL = direction === Directions.rightToLeft;
    const isArabic = isRTL && !isSSR && document.documentElement.lang === 'ar';
    const handleToggle = useCallback(() => {
        setDirection((previousDirection) => previousDirection === Directions.rightToLeft
            ? Directions.leftToRight
            : Directions.rightToLeft);
    }, []);
    const isLTR = !isRTL;
    const directionContext = (React.createElement(DirectionContext.Provider, { value: {
            isRTL,
            isLTR,
            isArabic,
            toggleDirection: handleToggle,
            direction,
            setDirection,
        } }, children));
    return directionContext;
};
export default DirectionProvider;
export const useDirection = () => {
    return useContext(DirectionContext);
};
